import { get_servers } from "@/code/axios";
import { ValidateServers } from "@/cfg/servers.js";

let cached_servers = [];
let last_update = undefined;
let cooldown = 5000;
let update_delay = 5 * 60 * 1000; // 5min
let update_delegate = undefined;
let error_delegate = undefined;

let update_handle = undefined;
let error_handle = undefined;

function update_cache() {
  if (last_update == undefined || Date.now() - last_update > cooldown) {
    return get_servers()
      .then((servers) => {
        last_update = Date.now();
        cached_servers = ValidateServers(servers);
        if (error_delegate) error_delegate(cached_servers.length <= 0 ? { detail: "no_servers" } : undefined);
        if (update_delegate) update_delegate(cached_servers);

        regular_update();
        return Promise.resolve();
      })
      .catch((e) => {
        if (error_delegate) error_delegate(e);
        retry();
      });
  }

  retry();
  return Promise.resolve();
}

function regular_update() {
  clearTimeout(update_handle);
  update_handle = setTimeout(() => {
    update_cache();
  }, update_delay);
}

function retry() {
  clearTimeout(error_handle);
  error_handle = setTimeout(() => {
    update_cache();
  }, cooldown);
}

function start_updates() {
  //console.log("autoupdates: On");
  clearTimeout(update_handle);
  update_cache();
}

function stop_updates() {
  //console.log("autoupdates: Off");
  clearTimeout(update_handle);
  clearTimeout(error_handle);
}

export { start_updates };
export { stop_updates };

window.addEventListener("focus", () => {
  start_updates();
});

window.addEventListener("blur", () => {
  stop_updates();
});

const tracker = {
  all: cached_servers,
  error: undefined,

  updateServers(servers) {
    tracker.all = servers;
  },

  updateError(error) {
    tracker.error = error;
  },
};

update_delegate = tracker.updateServers;
error_delegate = tracker.updateError;

const Plugin = {};
Plugin.install = function(Vue) {
  Vue.prototype.$servers = Vue.observable(tracker);
};

export default Plugin;
